const updates = [
  {
    date: '2026-07-31',
    title: '流浪地球3 4K修复版独家上线',
    desc: '郭帆导演亲自监修的4K修复版本今日正式登陆桔子影院，画质全面升级，新增30分钟导演剪辑片段。',
    tag: '上线',
  },
  {
    date: '2026-07-28',
    title: '平台CDN节点扩容完成',
    desc: '新增华南、西南两大核心节点，全国覆盖密度提升40%，晚间高峰时段播放流畅度大幅改善。',
    tag: '技术',
  },
  {
    date: '2026-07-25',
    title: '繁花似锦大结局超前点映',
    desc: '应广大观众呼声，繁花似锦最后三集提前解锁。截至目前全剧累计播放量突破35亿次。',
    tag: '更新',
  },
  {
    date: '2026-07-20',
    title: '暑期档特别策划专题上线',
    desc: '精心策划六大暑期观影专题，涵盖动作、科幻、动画等热门品类。每周更新精选片单。',
    tag: '策划',
  },
  {
    date: '2026-07-15',
    title: '移动端画质自适应功能上线',
    desc: '手机和平板用户现在可以享受智能画质调节，根据网络状况自动匹配最佳清晰度，流量更省。',
    tag: '功能',
  },
  {
    date: '2026-07-10',
    title: '长安十二时辰播放量破40亿',
    desc: '年度古装剧王再创纪录，总播放量正式突破40亿大关。为庆祝里程碑，全系列限时免广告。',
    tag: '里程碑',
  },
  {
    date: '2026-07-05',
    title: '用户反馈系统全面升级',
    desc: '全新的反馈通道已上线，支持一键提交播放问题与内容建议。我们的技术团队承诺24小时内响应。',
    tag: '服务',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">最新动态</h2>
          <p className="text-foreground-500 text-sm mt-2">桔子影院最新上线内容与技术更新</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/40 hidden sm:block"></div>

          <div className="flex flex-col gap-5">
            {updates.map((item, index) => (
              <div key={index} className="flex gap-5">
                <div className="hidden sm:flex flex-col items-center shrink-0 pt-0.5 relative z-10">
                  <div className="w-[9px] h-[9px] rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-5 border border-background-300/30 hover:border-primary-500/20 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-foreground-600 text-xs">{item.date}</span>
                    <span className="px-2 py-0.5 rounded-md bg-accent-500/15 text-accent-400 text-[10px] font-semibold whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-foreground-100 font-bold text-sm mb-1.5">{item.title}</h3>
                  <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}